<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="10">
        <base-material-card
          icon="mdi-map-check"
          :title="fuel.id? $i18n.t('Edit Fuel - ') + fuel : $i18n.t('Create Fuel')"
          class="px-3 py-3 small-icon"
        >
          <v-form id="form" ref="form" v-model="valid">
            <v-row>
              <v-col cols="12" md="4">
                <z-vehicle-select
                  class="purple-input"
                  v-model="fuel.vehicle_id"
                  clearable
                  idOnly
                  :rules="validationrules.vehicle"
                  required
                  dense
                />
              </v-col>
              <v-col cols="12" md="4">
                <z-driver-select
                  class="purple-input"
                  v-model="fuel.driver_id"
                  clearable
                  idOnly
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <z-fuel-pump-select
                  :label="$i18n.t('Fuel Pump') + '*'"
                  class="purple-input"
                  v-model="fuel.pump_id"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="4">
                <z-date-picker
                  :label="$i18n.t('Date')"
                  class="purple-input"
                  v-model="fuel.time"
                  timestamp
                />
              </v-col>

              <v-col cols="12" md="4">
                <z-time-picker
                  :label="$i18n.t('Time')"
                  class="purple-input"
                  v-model="fuel.time"
                  timestamp="fuel.time"
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="4">
                <v-select
                  :items="fuelTypes"
                  :label="$i18n.t('Fuel Type') + '*'"
                  v-model="fuel.fuelType"
                  :rules="validationrules.fuelType"
                  required
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  :items="qtyTypes"
                  :label="$i18n.t('Quantity Type') + '*'"
                  v-model="fuel.qtyType"
                  :rules="validationrules.qtyTypes"
                  required
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  :label="$i18n.t('Quantity') + '*'"
                  class="purple-input"
                  v-model="fuel.qty"
                  :rules="validationrules.qty"
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  :label="$i18n.t('Current KMs Reading') + '*'"
                  class="purple-input"
                  v-model="fuel.kms"
                  :rules="validationrules.KM"
                  required
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  :label="$i18n.t('Reciept No') + '*'"
                  class="purple-input"
                  v-model="fuel.receiptNo"
                  :rules="validationrules.receiptNo"
                  required
                />
              </v-col>
              <v-col cols="12" md="4">
                <z-currency-select
                  :label="$i18n.t('Currency') + '*'"
                  class="purple-input"
                  v-model="fuel.currency"
                  :rules="validationrules.currency"
                  required
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  :label="$i18n.t('Cost') + '*'"
                  class="purple-input"
                  v-model="fuel.cost"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fuel.isOutstation" :label="$i18n.t('For Outstation')" />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fuel.cash" :label="$i18n.t('Paid in Cash')" />
              </v-col>
            </v-row>
            <v-col cols="12" md="4">
              <v-file-input
                chips
                multiple
                :label="$i18n.t('Attachments')"
                @change="handleFileUpload()"
                v-model="file"
              ></v-file-input>
            </v-col>
            <v-row>
              <div
                class="subtitle-1 font-weight-light"
                v-if="fuel.receiptUrl"
              >{{ $i18n.t("Attachment") }}</div>
              <v-img :src="fuel.receiptUrl" style="height:40px;width:45px" />
            </v-row>

            <v-col cols="12" class="text-right">
              <v-btn
                color="success"
                class="mr-0"
                @click="save()"
                :loading="loading"
                :disabled="!valid"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPostForm } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  valid = true;
  fuelTypes = ["Diesel", "Petrol", "CNG", "Electric"];
  qtyTypes = ["Litre", "KG", "KW"];
  fuel = {};
  file = null;
  date = 1588056867;
  validationrules = {
    vehicle: [(v) => !!v || this.$i18n.t("Vehicle is required")],
    Driver: [(v) => !!v || this.$i18n.t("Driver is required")],
    FuelType: [(v) => !!v || this.$i18n.t("Fuel Type is required")],
    qtyTypes: [(v) => !!v || this.$i18n.t("Quantity Type is required")],
    qty: [(v) => !!v || this.$i18n.t("Quantity is required")],
    KM: [(v) => !!v || this.$i18n.t("KM Type is required")],
    ReceiptNo: [(v) => !!v || this.$i18n.t("Receipt No Type is required")],
    currency: [(v) => !!v || this.$i18n.t("Currency is required")],
  };
  id = "";

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      common.setLoading(true);
      const formData = new FormData();

      if (this.id) {
        formData.set("_id", this.fuel._id);
      }
      // let time = moment('2016-10-11 18:06:03') ;

      formData.set("vehicle_id", this.fuel.vehicle_id);
      formData.set("pump_id", this.fuel.pump_id);
      formData.set("time", this.fuel.time);
      formData.set("receiptNo", this.fuel.receiptNo);
      formData.set("qty", this.fuel.qty);
      formData.set("qtyType", this.fuel.qtyType);
      formData.set("kms", this.fuel.kms);
      formData.set("fuelType", this.fuel.fuelType);
      formData.set("driver_id", this.fuel.driver_id);
      formData.set("cost", this.fuel.cost);
      formData.set("cash", this.fuel.cash);
      formData.set("isOutstation", this.fuel.isOutstation);
      formData.set("currency", this.fuel.currency);
      if (this.file && this.file.length > 0) {
        formData.append("receiptUrl", this.file[0]);
      }
      const url = "/api/fuel/save";
      // if (this.fuel._id) {
      //   url = "/api/fuel/edit";
      // }
      await doPostForm(url, formData);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.fuel = await doGet("/api/fuel/" + id + "/detail");
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }
  handleFileUpload(files) {
    if (files) {
      this.file = files[0];
    }
  }
}
</script>

<style scoped>
.week-button {
  padding: 5px 4px;
  height: 30px;
  width: 30px;
  justify-content: center;
}
</style>
